/**
 * An enumeration of all the fragment types used within DAS.
 */
export enum DASFragmentType {
  HTML = 'HTML',
  DEPARTURE = 'DEPARTURE',
  LOCATION = 'LOCATION',
  ATTACHMENT = 'ATTACHMENT',
  INFORMATION = 'INFORMATION',
  CONDITION = 'CONDITION',
  LINKED_DEPARTURE = 'LINKED_DEPARTURE',
}
